import { useQuery } from "@tanstack/react-query";
import { AIAgentDefinitions } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "aiagent/AgentWorkflows/Constants";
export const ENABLED_WORKFLOW_COUNT_QUERY_KEY = [...WORKFLOW_DEFINITIONS_QUERY_KEY, "enabled-count"];
const useEnabledWorkflowCount = () => {
  const { data, isLoading } = useQuery({
    queryKey: ENABLED_WORKFLOW_COUNT_QUERY_KEY,
    queryFn: () => defaultOnError(
      AIAgentDefinitions.enabledCount().then(({ count }) => count),
      "Loading enabled agent workflows failed",
      "Could not load enabled agent workflows"
    )
  });
  return { data: data != null ? data : 0, isLoading };
};
export default useEnabledWorkflowCount;
